import { Field, Picker, Popup } from "vant"
import { computed, defineComponent, ref } from "vue"
import styles from "./index.module.less"

const isNever = (value) => {
  if (value === null) return true
  else if (value === undefined) return true
  return false
}

export default defineComponent({
  name: "MobilePicker",
  props: {
    modelValue: { type: [String, Number] },
    columns: { type: Array, default: () => [] },
    placeholder: String,
    disabled: Boolean,
    title: String,
    config: { type: Object, default: () => ({}) }
  },
  emits: ["update:modelValue", "confirm", "change"],
  setup(props, { attrs, emit, slots }) {
    const visible = ref(false)

    const insideValue = ref([])

    const columnsFieldNames = computed(() => {
      const { columnsFieldNames } = props.config
      return {
        text: "text",
        values: "values",
        children: "children",
        value: "value",
        ...columnsFieldNames
      }
    })

    const selectedColumn = computed(() => {
      const { columns } = props
      const { value: valueKey } = columnsFieldNames.value
      return columns.find(({ [valueKey]: id }) => {
        return id === props.modelValue
      })
    })

    const popupProps = computed(() => {
      return {
        round: true,
        closeOnPopstate: true,
        position: "bottom",
        teleport: "body"
      }
    })

    const pickerProps = computed(() => {
      return {
        columns: props.columns,
        title: props.title || props.placeholder,
        ...props.config,
        onConfirm: (selected) => {
          const { selectedValues } = selected
          emit("update:modelValue", selectedValues[0])
          emit("change", selected)
          emit("confirm", selected)
          visible.value = false
        },
        onCancel: () => {
          visible.value = false
        }
      }
    })

    const showValue = computed(() => {
      const { text } = columnsFieldNames.value
      if (selectedColumn.value) return selectedColumn.value[text]
      else return ""
    })

    const fieldProps = computed(() => {
      return {
        readonly: true,
        disabled: props.disabled,
        rightIcon: props.disabled ? "" : "arrow",
        placeholder: props.placeholder,
        class: [styles.input]
      }
    })

    const show = () => {
      if (!props.disabled) {
        insideValue.value = isNever(props.modelValue) ? [] : [props.modelValue]
        visible.value = true
      }
    }

    const renderField = () => {
      if (slots.field) return slots.field(showValue.value)
      else {
        return <Field {...fieldProps.value} modelValue={showValue.value} />
      }
    }

    return () => [
      <div class={["grow-1", attrs.class]} onClick={show}>
        {renderField()}
      </div>,
      <Popup vModel:show={visible.value} {...popupProps.value}>
        <Picker vModel={insideValue.value} {...pickerProps.value} />
      </Popup>
    ]
  }
})
